<template lang="pug">
  .items-start.flex.flex-col(class="lg:flex-row lg:items-center lg:flex-wrap")
    .flex.items-center.shrink-1.rounded-20.bg-main-0.py-8.pl-20.pr-12.mr-12.my-6(v-if="hasAllOption && itemList.length" class="lg:")
      .text-white.cursor-default.pt-2 {{$t('__c6N3.__all')}}
      button.rounded-50.bg-white.w-20.h-20.ml-12(
      class="hover:bg-main-deep active:bg-main-deep"
      @click="deleteFilter()")
        iCon.h-20.w-20(:iconClass="'ico_Close'" type="svg" class="text-grey-97 active:text-white hover:text-white" )
    
    .flex.items-center.rounded-20.bg-main-0.py-8.pl-20.pr-12.mr-12.my-6(v-for="(one , index) in itemList" :class="{'bg-main-disable': one.disabled}") 
      .text-white.cursor-default.pt-2 {{one.name}}
      button.rounded-50.bg-white.w-20.h-20.ml-12(
      :class="{'hover:bg-main-deep' : !one.disabled, 'active:bg-main-deep' :!one.disabled ,'cursor-pointer': !one.disabled ,'cursor-not-allowed' : one.disabled}"
      @click="deleteFilter(one, index)")
        iCon.h-20.w-20(:iconClass="one.icon ? one.icon : 'ico_Close'" type="svg" class=" " :class="{'text-grey-97': one.disabled ,'active:text-white' : !one.disabled, 'hover:text-white' :!one.disabled}")
    .underline.cursor-pointer.text-text-gray.mt-10(@click="deleteFilter()" 
      class="lg:mt-0"
      v-if="clearAll && itemList ? itemList.length : itemList")  {{$t('__c6N3.__clearAll')}}
</template>

<script>
//.grow-0.shrink-1

export default {
  name: 'FilterTab',
  components: {
  },
  props: {
    type: String,
    itemList: {
      type: Array,
      // required: true,
    },
    clearAll: {
      type: Boolean,
      // required: true,
    },
    hasAllOption:{ //有All選項
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShow: this.show,
    };
  },
  mounted(){
    this.isShow = this.show;
  },
  methods: {
    deleteFilter(one,index){
      if(!one){
        this.$emit('deleteFilter', 'all');
        return
      }else{
        if(one.disabled) return
        this.$emit('deleteFilter', index);
      }
    },
  },
  watch:{
  }
};
</script>

<style lang="scss" scoped>



</style>